// One tap: the phone's own e-mail, WhatsApp or Call. Nothing is sent by Hey Captain, nothing costs anything. A button only shows when the detail exists.
import { contactLinks } from './core'

const ICON = {
  email: <path d="M3 6.5h18v11H3zM3.5 7l8.5 6.5L20.5 7" />,
  whatsapp: <path d="M4 20l1.3-4A8 8 0 1 1 8.2 19zM9 8.5c-.5 3 3.5 7 6.5 6.5l1-1.7-2.3-1.2-1 .9a6 6 0 0 1-2.2-2.2l.9-1-1.2-2.3z" />,
  call: <path d="M5 4h4l1.5 5-2.2 1.6a12 12 0 0 0 5.1 5.1L15 13.5l5 1.5v4a1.5 1.5 0 0 1-1.6 1.5C10.8 20 4 13.2 3.5 5.6A1.5 1.5 0 0 1 5 4z" />,
}
export default function ContactButtons({ email, phone, whatsapp, subject, text, compact = false, style }) {
  const links = contactLinks({ email, phone, whatsapp, subject, text })
  if (!links.length) return null
  return (
    <span className="hc-contact" style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 6, ...style }} onClick={e => e.stopPropagation()}>
      {links.map(l => (
        <a key={l.kind} href={l.href} data-contact={l.kind} target={l.kind === 'whatsapp' ? '_blank' : undefined} rel={l.kind === 'whatsapp' ? 'noopener noreferrer' : undefined} title={l.label} aria-label={l.label}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: compact ? '3px 7px' : '5px 10px', minHeight: compact ? 24 : 30, fontSize: 12, fontWeight: 600, borderRadius: 7, border: '1px solid var(--line-2, var(--border))', color: 'var(--text)', background: 'transparent', textDecoration: 'none', whiteSpace: 'nowrap', boxSizing: 'border-box' }}>
          <svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">{ICON[l.kind]}</svg>{compact ? '' : l.label}
        </a>
      ))}
    </span>
  )
}
